import { RefOption } from "../../../services/agenda/types";

export interface ICacheManager {
  get(code: string): RefOption[] | null;
  set(code: string, options: RefOption[]): void;
  has(code: string): boolean;
  clear(): void;
  getCachedKeys(): string[];
}

export class RefOptionsCacheManager implements ICacheManager {
  private cache: Map<string, RefOption[]> = new Map();

  get(code: string): RefOption[] | null {
    return this.cache.get(code) || null;
  }

  set(code: string, options: RefOption[]): void {
    this.cache.set(code, [...options]);
  }

  has(code: string): boolean {
    return this.cache.has(code);
  }

  clear(): void {
    this.cache.clear();
  }

  getCachedKeys(): string[] {
    return Array.from(this.cache.keys());
  }
}
